function WindowSize(width, height) {

    var self = this;

    // Private Variables
    var resizeFunctions = [];
    var timeoutResize;

    // Observables
    self.width = ko.observable(width || 0);
    self.height = ko.observable(height || 0);

    // Computeds
    self.bootstrapSize = ko.computed(function() {
        if (self.width() >= cccApp.enums.boostrapSizes.lg) {
            return cccApp.enums.boostrapSizes.lg.name;
        } else if (self.width() >= cccApp.enums.boostrapSizes.md) {
            return cccApp.enums.boostrapSizes.md.name;
        } else if (self.width() >= cccApp.enums.boostrapSizes.sm) {
            return cccApp.enums.boostrapSizes.sm.name;
        }

        return cccApp.enums.boostrapSizes.xs.name;
    });

    // Public Functions
    self.addResizeCallback = function (firstId, secondId, offset) {

        offset = offset || 0;

        if (typeof (resizeFunctions) === "object" && resizeFunctions.length > 0) {
            for (var i = 0; i < resizeFunctions.length; i++) {
                if (typeof (resizeFunctions[i]) === "object") {
                    if (resizeFunctions[i].first === firstId && resizeFunctions[i].second === secondId) {
                        return;
                    }
                }
            }
        }

        resizeFunctions.push({ first: firstId, second: secondId, offset: offset });
    };

    self.triggerResizeCallbacks = function()
    {
        if (timeoutResize) {
            return;
        }

        if (typeof(resizeFunctions) === "object" && resizeFunctions.length > 0) {
            timeoutResize = setTimeout(function () {
                for (var i = 0; i < resizeFunctions.length; i++) {
                    if (typeof (resizeFunctions[i].first) === "string" && typeof (resizeFunctions[i].second) === "string") {

                        if (self.width() >= cccApp.enums.boostrapSizes.md) {
                            var resizeFunction = resizeFunctions[i];
                            if (resizeFunction) {
                                cccApp.ui.equalizeIconNavHeight(resizeFunction.first, resizeFunction.second, resizeFunction.offset);
                            }
                        } else {
                            cccApp.ui.cancelEqualizedHeight(resizeFunctions[i].first, resizeFunctions[i].second);
                        }
                    }
                }
                timeoutResize = 0;
            }, 500);
        }
    }
}